import classnames from 'classnames';
import * as React from 'react';
import { text, color, size, weight } from './text.css.js';

const defaultElement = 'span';
/**
 * Renders text with specified typographic styles.
 */
const Text = React.forwardRef(function Text({ as, kind, prominence, size: size$1 = 'inherit', weight: weight$1 = 'regular', className, ...rest }, ref) {
    const Element = as || defaultElement;
    const color$1 = kind === undefined && prominence === undefined ? 'inherit' : `${kind ?? 'neutral'}-${prominence ?? 'default'}`;
    return (React.createElement(Element, { className: classnames(text, color[color$1], size[size$1], weight[weight$1], className), ref: ref, ...rest }));
});

export { Text };
